<section class="pqn" id="por-que-nosotros">
  <div class="pqn__container">
    <!-- Cabecera -->
    <header class="pqn__header">
      <p class="pqn__label">Por qué nosotros</p>
      <h2 class="pqn__title">Por qué TodoSector</h2>
      <p class="pqn__intro">
        Fichaje suelto o suite complicada: siempre acabas pagando de más o
        pegando herramientas que no encajan. Nosotros conectamos lo esencial
        desde el primer día.
      </p>
    </header>

    <!-- Tabla comparativa -->
    <div class="pqn__table-wrap">
      <div class="pqn__table" role="table">
        <!-- Cabecera de la tabla -->
        <div class="pqn__row pqn__row--head" role="row">
          <div class="pqn__cell pqn__cell--feature" role="columnheader"></div>
          @for (col of columns; track col.name) {
            <div
              class="pqn__cell pqn__cell--col"
              [class.pqn__cell--highlight]="col.highlight"
              role="columnheader">
              @if (col.highlight) {
                <span class="pqn__col-badge">Recomendado</span>
              }
              <span class="pqn__col-name">{{ col.name }}</span>
              @if (col.sub) {
                <span class="pqn__col-sub">{{ col.sub }}</span>
              }
            </div>
          }
        </div>

        <!-- Filas -->
        @for (row of rows; track row.feature) {
          <div class="pqn__row" role="row">
            <div class="pqn__cell pqn__cell--feature" role="rowheader">
              <span class="pqn__feature">{{ row.feature }}</span>
              @if (row.detail) {
                <span class="pqn__detail">{{ row.detail }}</span>
              }
            </div>
            @for (cell of row.cells; track $index) {
              <div
                class="pqn__cell pqn__cell--value"
                [class.pqn__cell--highlight]="columns[$index].highlight"
                role="cell">
                <span class="pqn__cell-label">{{ columns[$index].name }}</span>
                @if (cell.text) {
                  <span class="pqn__text pqn__text--{{ cell.state }}">
                    {{ cell.text }}
                  </span>
                } @else {
                  <i
                    class="pqn__icon pqn__icon--{{ cell.state }} ph"
                    [class.ph-check]="cell.state === 'yes'"
                    [class.ph-x]="cell.state === 'no'"
                    [class.ph-minus]="cell.state === 'partial'"
                    aria-hidden="true"></i>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>

    <!-- Callout: coste con plantilla operativa -->
    <div class="pqn__callout">
      <i class="ph ph-users-three" aria-hidden="true"></i>
      <p>
        Una empresa de <strong>20 personas</strong> (3 en gestión + 17 que solo
        fichan) arranca <strong>desde 45 €/mes</strong>: los 17 operativos no
        cuestan nada. En un sistema que cobra por usuario, lo mismo se va a
        varios cientos de euros al mes.
      </p>
    </div>

    <!-- Cierre -->
    <div class="pqn__closing">
      <p class="pqn__quote">
        «Empieza con lo esencial y, cuando necesites algo único, lo
        desarrollamos según tus necesidades unificando tu sistema.»
      </p>
      <a class="pqn__cta" routerLink="/precios">
        Ver precios y planes
        <i class="ph ph-arrow-right" aria-hidden="true"></i>
      </a>
    </div>
  </div>
</section>
